/**
 * Returns true if an event is loaded
 * @param {object} state
 * @param {string} id
 * @returns {boolean}
 */
export const eventIsLoaded = (state, id) => {
  const { events } = state
  return Boolean(events[id] && events[id].created)
}